import React from 'react';

import Breadcrumb, { BreadcrumbGroup } from '@amzn/meridian/breadcrumb';

import { useHistory } from 'react-router-dom';
import { IBreadcrumb } from 'src/types/IBreadcrumb';

import './Breadcrumb.scss';

interface IBreadcrumbItemsProps {
    breadcrumbItems: IBreadcrumb[];
    handleRedirect?: () => boolean;
    showBottomBorder?: boolean;
}

export const BreadcrumbWrapper = ({
    breadcrumbItems,
    handleRedirect,
    showBottomBorder = false
}: IBreadcrumbItemsProps) => {
    const history = useHistory();
    const handleOnclick = (value: string) => {
        if (!(handleRedirect && handleRedirect())) {
            history.push(value);
        }
    };

    return (
        <div className={`breadcrumb ${showBottomBorder ? 'breadcrumb-bottom-border' : ''}`}>
            <BreadcrumbGroup>
                {breadcrumbItems.map((item, index) => (
                    <Breadcrumb key={index} href={item.link} onClick={(value) => handleOnclick(value)}>
                        {item.title}
                    </Breadcrumb>
                ))}
            </BreadcrumbGroup>
        </div>
    );
};
